import React from 'react';
import { Course } from '../../../types/grades';

interface CourseCodeInputProps {
  course: Course;
  onChange: (updatedCourse: Course) => void;
}

export function CourseCodeInput({ course, onChange }: CourseCodeInputProps) {
  const handleChange = (value: string) => {
    // Remove spaces and convert to uppercase
    const formattedCode = value.replace(/\s+/g, '').toUpperCase();
    onChange({ ...course, code: formattedCode });
  };

  return (
    <div className="col-span-1 sm:col-span-2 lg:col-span-1">
      <label className="block text-sm font-medium text-gray-700 mb-1.5">
        Course Code
        {course.isRetake && (
          <span className="ml-2 text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">
            Retake
          </span>
        )}
      </label>
      <input
        type="text"
        value={course.code}
        onChange={(e) => handleChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md 
                   focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                   transition-colors duration-200"
        placeholder="e.g. MATH101"
      />
    </div>
  );
}